import React, { Component, useRef } from "react";
import Header from "../../../components/user/common/Header";
import PageTitle from "../../../components/user/common/PageTitle";
import Footer from "../../../components/common/Footer";
import { connect } from "react-redux";
import { setLoading } from '../../../store/reducers/global-reducer';
import axios from "axios";
import * as Yup from 'yup';
import { Formik, Field, FieldArray, ErrorMessage } from 'formik';
import { Box, Text } from "rebass";
import styled from "styled-components";
import { toast } from "react-toastify";
import store from "../../../store/index";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import arrow_back from '../../../assets/icons/arrow-back.svg';
import StripeCheckoutElements from "./StripeCheckoutElements";
import { useLocation } from 'react-router-dom';
import {clearCart} from "../../../store/reducers/cart-slice-reducer"

import { stripePromise, publishableKey } from "../../../config/stripe";

class CheckOut extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef;
        this.authInfo = store.getState().auth.authInfo;
        this.state = {
            userDetails: {},
            formStatus: false,
            chargeData: "",
            checkoutData: "",
            apiData: [],
            statusData: [],
            orderStatus: [],
            paymentId: "",
            productSku: [],
            sellerId: null,
            status: "unpaid",
            data: [],
            reqBody: {
                count: {
                    page: 1,
                    skip: 0,
                    limit: 2,
                    data: "",
                },
                sorting: {
                    sort_type: "date",
                    sort_val: "desc",
                },
            },
            autherStatus: "",
            user_id: "",
            paymentType: "",
            moneyComparision: false,
            stripeData: this.props.location?.state || {},
            stripeClientSecret: this.props.location?.state?.client_secret || "",
            isMilestoneOrder: this.props.location?.state?.isMilestoneOrder || false,
            milestoneData: this.props.location?.state?.milestoneData ||
                            JSON.parse(localStorage.getItem('pendingMilestoneData') || 'null'),
            pendingMilestones: []
        };

        const { milestoneData } = this.state;
        const firstMilestoneId = milestoneData?.firstMilestoneId;
        console.log("First Milestone ID:", firstMilestoneId);

        if (firstMilestoneId) {
            localStorage.setItem('currentFirstMilestoneId', firstMilestoneId);
        }
    }

    /**
     * Manages payment Data - ENHANCED to ensure cart data is properly included
     */
    managePaymentData = async (paymentData) => {
        try {
            console.log("=== CHECKOUT: managePaymentData ===");
            console.log("Payment data being sent:", JSON.stringify(paymentData, null, 2));

            // Ensure cart data is included in payment data
            if (Array.isArray(paymentData) && paymentData.length > 0) {
                const cart = this.props.cart || [];

                // Enhanced cart data with all necessary fields
                const enhancedCart = cart.map(item => ({
                    ...item,
                    // Ensure sellerId is available from multiple sources
                    sellerId: item.createdBy || item.sellerId || item.seller_id,
                    // Add any other necessary fields
                    productId: item.id,
                    name: item.name || item.title,
                    price: item.price || 0,
                    quantity: item.quantity || 1
                }));

                // Add cart data to payment data
                paymentData[0].cart = enhancedCart;

                // Extract sellerId if not already present
                if (!paymentData[0].sellerId && enhancedCart.length > 0) {
                    const firstValidSellerId = enhancedCart.find(item => item.sellerId)?.sellerId;
                    if (firstValidSellerId) {
                        paymentData[0].sellerId = firstValidSellerId;
                        console.log("Added sellerId from enhanced cart:", firstValidSellerId);
                    }
                }

                console.log("Enhanced payment data with cart:", JSON.stringify(paymentData, null, 2));
            }

            let res = await axios.post("user/savepayment", paymentData, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${this.authInfo.token}`,
                },
            });

            console.log("Payment API response:", res.data);

            let productid = res.data.data;
            if (typeof productid != "undefined") {
                return productid;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error managing payment data:', error);
            if (error.response) {
                console.error('API error response:', error.response.data);
            }
            return false;
        }
    };

    // Milestone-specific order submission method
    onMilestoneSubmitHandler = (event) => {
        event.preventDefault();
        const { milestoneData } = this.state;

        if (!milestoneData) {
            toast.error("Milestone data not found");
            return;
        }

        // Check if status is an array and has paid status
        const statusArray = Array.isArray(this.state.status) ? this.state.status : [this.state.status];
        if (statusArray[0] === "paid") {
            let orderStatusData = this.state.orderStatus;
            let orderStatus = "6137423b2651fc157c545d50"; // Default pending status

            // Set order status to completed for milestone payment
            if (Array.isArray(orderStatusData) && orderStatusData.length > 0) {
                orderStatusData.forEach((d) => {
                    if (d.title == "Completed") {
                        orderStatus = d._id;
                    }
                });
            }

            // Create productSku array for milestone
            const productSku = [{
                productId: milestoneData.productId,
                quantity: milestoneData.currentMilestone?.quantity || 1,
                price: milestoneData.currentMilestone?.amount || 0,
                sellerId: milestoneData.sellerId,
                milestoneIndex: milestoneData.currentMilestone?.index || 0,
                milestoneName: milestoneData.currentMilestone?.name || 'Milestone'
            }];

            // Create order using existing structure
            const orderPayload = {
                userId: this.authInfo.id,
                projectId: milestoneData.projectId,
                sellerId: milestoneData.sellerId,
                productSku: productSku,

                // Billing details from form state
                billingFirstName: this.state.billingFirstName || '',
                billingLastName: this.state.billingLastName || '',
                billingCity: this.state.billingCity || '',
                billingCompanyName: this.state.billingCompanyName || '',
                billingCounty: this.state.billingCounty || '',
                billingNote: this.state.billingNote || '',
                billingPhone: this.state.billingPhone || '',
                billingPostCode: this.state.billingPostCode || '',
                billingStreetAddress: this.state.billingStreetAddress || '',
                billingStreetAddress1: this.state.billingStreetAddress1 || '',
                billingEmail: this.state.billingEmail || '',

                // Financial details
                deliveryCharge: 0,
                taxPercent: 0,
                taxAmount: 0,
                discount: 0,
                price: milestoneData.currentMilestone?.amount || 0,
                total: milestoneData.currentMilestone?.amount || 0,

                // Order status and type
                orderStatus: orderStatus,
                paymentId: this.state.paymentId,
                isActive: true,
                isService: true,
                isMilestonePayment: true
            };

            console.log('Creating milestone order:', orderPayload);

            // Use existing saveorder endpoint
            axios.post("user/saveorder", orderPayload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${this.authInfo.token}`,
                },
            })
            .then((response) => {
                if (response.data && response.data.data) {
                    const orderId = response.data.data;

                    this.props.dispatch(clearCart());
                    this.clearCartData();

                    localStorage.removeItem('pendingMilestoneData');
                    localStorage.removeItem('checkoutCartData');
                    localStorage.removeItem('stripeCheckoutCart');
                    localStorage.removeItem('pendingOrderClear');

                    // Store remaining milestones in localStorage for later
                    if (milestoneData.allMilestones && Array.isArray(milestoneData.allMilestones)) {
                        const remainingMilestones = milestoneData.allMilestones.slice(1).map(milestone => ({
                            ...milestone,
                            projectId: milestoneData.projectId
                        }));
                        localStorage.setItem(`milestones_${milestoneData.projectId}`, JSON.stringify(remainingMilestones));
                    }

                    // Clear pending milestone data
                    localStorage.removeItem('pendingMilestoneData');

                    // Add order timeline using existing method
                    this.addOrderTimeLine(orderId, orderStatus);

                    // Save order details using existing method
                    this.saveOrderDetails(orderId, productSku, orderStatus);

                    toast.dismiss();
                    toast.success("First milestone payment completed successfully!", { autoClose: 3000 });

                    // Redirect to a milestone management page or order summary
                    this.props.history.push(`/milestone-project/${milestoneData.projectId}`);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("Failed to process milestone payment");
            });
        } else {
            toast.dismiss();
            toast.error("Payment not completed. Please try again.");
        }
    };

    clearCartData = async () => {
        const { id, token } = this.authInfo;

        try {
            console.log("CLEARING CART")
            const response = await axios.delete(`user/clearCartData/${id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${token}`,
                }
            });

            if (response.data.status) {
                console.log('Cart cleared from database');
            } else {
                console.error('Failed to clear cart from database');
            }
        } catch (error) {
            console.error('Error clearing cart from database:', error);
        }
    };

    /**
     * Enhanced method to prepare cart data for Stripe metadata
     */
    prepareCartDataForStripe = () => {
        const cart = this.props.cart || [];
        const { isMilestoneOrder, milestoneData } = this.state;

        let cartToSend = [];
        let sellerId = null;

        if (isMilestoneOrder && milestoneData) {
            // For milestone orders
            cartToSend = milestoneData.milestoneCart || [];
            sellerId = milestoneData.sellerId;
        } else {
            // For regular orders - enhance cart with all necessary data
            cartToSend = cart.map(item => ({
                ...item,
                id: item.id,
                productId: item.id, // Ensure productId is available
                name: item.name || item.title,
                price: item.price || 0,
                quantity: item.quantity || 1,
                sellerId: item.createdBy || item.sellerId || item.seller_id,
                // Add any other fields that might be needed
                color: item.color || "",
                size: item.size || "",
                image: item.image || item.featuredImage || "",
                categoryId: item.categoryId || item.category
            }));

            // Extract sellerId from the first valid item
            sellerId = cartToSend.find(item => item.sellerId)?.sellerId || null;
        }

        console.log("=== PREPARED CART DATA FOR STRIPE ===");
        console.log("cartToSend:", cartToSend);
        console.log("sellerId:", sellerId);

        return { cartToSend, sellerId };
    };

    /**
     * Initialize instance and function on did mount
     */
    componentDidMount() {
        const clientSecret = this.props.location?.state?.client_secret;
        if (clientSecret && clientSecret !== this.state.stripeClientSecret) {
            this.setState({
                stripeClientSecret: clientSecret,
                stripeData: this.props.location?.state || {},
            });
        }

        this.getNewCouponCode();
        this.getOrderStaus();
        this.getProductSku();
        this.getUserData();

        // Store cart data in localStorage as backup for complete page
        const cart = this.props.cart || [];
        if (cart.length > 0) {
            const cartWithSellerId = cart.map(item => ({
                ...item,
                sellerId: item.createdBy || item.sellerId || item.seller_id
            }));
            localStorage.setItem('checkoutCartData', JSON.stringify(cartWithSellerId));
            console.log("Stored cart data in localStorage for complete page");
        }
    }

    componentDidUpdate(prevProps) {
        const currentSecret = this.props.location?.state?.client_secret;
        const prevSecret = prevProps.location?.state?.client_secret;
        if (currentSecret && currentSecret !== prevSecret && currentSecret !== this.state.stripeClientSecret) {
            this.setState({
                stripeClientSecret: currentSecret,
                stripeData: this.props.location?.state || {},
            });
        }
    }

    getUserData = () => {
        const userId = this.authInfo.id
        axios.get('user/my-profile/' + userId, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${this.authInfo.token}`
            }
        }).then((response) => {
            if (response.data.status) {
                let resData = response.data.data;
                this.setState({
                    userDetails: resData,
                });
            }
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            setTimeout(() => {
                // dispatch(setLoading({ loading: false }));
            }, 300);
        });
    }

    /**
     * Get the seller id by product id
     */
    getSellerId = async (productId) => {
        try {
            let res = await axios.get("user/sellerid/" + productId, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: `Bearer ${this.authInfo.token}`,
                },
            });
            let sellerid = res.data.data;
            if (sellerid) {
                return sellerid;
            }
            return false;
        } catch (error) {
            console.error('Error getting seller ID:', error);
            return false;
        }
    };

    /**
     * Get order status data
     */
    getOrderStaus = () => {
        axios.get("user/orderstatus", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
        .then((response) => {
            if (response.data && response.data.data) {
                this.setState({ orderStatus: Array.isArray(response.data.data) ? response.data.data : [] });
            } else {
                this.setState({ orderStatus: [] });
            }
        })
        .catch((error) => {
            console.log(error);
            this.setState({ orderStatus: [] });
        });
    };

    /**
     *  get new Coupon code
     */
    getNewCouponCode = () => {
        let reqBody = this.state.reqBody;
        axios.post("user/coupons/new", reqBody, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
        .then((response) => {
            this.setState({ data: response.data?.data?.coupons || [] });
        })
        .catch((error) => {
            console.log(error);
            this.setState({ data: [] });
        });
    };

    /**
     * Get product details with safety checks
     */
    getProductSku = () => {
        const cart = this.props.cart || [];

        if (!Array.isArray(cart) || cart.length === 0) {
            console.warn('Cart is empty or undefined');
            this.setState({ productSku: [], sellerId: null });
            return;
        }

        console.log("=== EXTRACTING SELLER INFO FROM CART ===");
        console.log("Cart items:", cart);

        let product_sku = [];
        let firstSellerId = null;

        cart.forEach((item, index) => {
            if (item && item.id) {
                // Use createdBy as sellerId
                const sellerId = item.createdBy || item.sellerId || item.seller_id || null;

                console.log(`Item ${index + 1}:`, {
                    id: item.id,
                    name: item.name,
                    createdBy: item.createdBy,
                    sellerId: sellerId
                });

                if (sellerId) {
                    product_sku.push({
                        productId: item.id,
                        quantity: item.quantity || 1,
                        price: item.price || 0,
                        color: item.color || "",
                        size: item.size || "",
                        sellerId: sellerId, // Use createdBy as sellerId
                        name: item.name || item.title || "",
                        categoryId: item.categoryId || item.category || null,
                    });

                    // Store the first sellerId found
                    if (!firstSellerId) {
                        firstSellerId = sellerId;
                    }
                } else {
                    console.warn(`No sellerId found for item:`, item);
                }
            }
        });

        console.log("=== FINAL PRODUCT SKU ===");
        console.log("product_sku:", product_sku);
        console.log("firstSellerId:", firstSellerId);

        this.setState({
            productSku: product_sku,
            sellerId: firstSellerId
        });
        if (firstSellerId) {
            localStorage.setItem('lastKnownSellerId', firstSellerId);
            console.log("Stored sellerId in localStorage:", firstSellerId);
        }
    };

    /**
     * Get total amount and multiple data with safety checks
     */
    getTotal = () => {
        const { isMilestoneOrder, milestoneData } = this.state;

        if (isMilestoneOrder && milestoneData && milestoneData.currentMilestone) {
            // For milestone orders, calculate based on current milestone
            return {
                totalPrice: milestoneData.currentMilestone.amount || 0,
                totalQuantity: milestoneData.currentMilestone.quantity || 1,
                totalAmmount: milestoneData.currentMilestone.amount || 0,
                discount: 0,
                tax: 0
            };
        }

        // Original logic for regular cart orders
        const cart = this.props.cart || [];

        if (!Array.isArray(cart) || cart.length === 0) {
            return {
                totalPrice: 0,
                totalQuantity: 0,
                totalAmmount: 0,
                discount: 0,
                tax: 0
            };
        }

        const newDesApi = Array.isArray(this.state.apiData) ? this.state.apiData : [];
        var newDiscount = "";
        newDesApi.forEach((val) => {
            newDiscount = val.discount_per;
        });

        let totalQuantity = 0;
        let disCode = newDiscount;
        let totalPrice = 0;
        let GST = 18;
        let totalAmmount = 0;
        let discount = 0;
        let tax = 0;

        cart.forEach((items) => {
            if (items && typeof items.quantity === 'number' && typeof items.price === 'number') {
                totalQuantity += items.quantity;
                totalPrice += items.price * items.quantity;
                tax = (totalPrice * GST) / 100;

                if (disCode === undefined) {
                    discount = 0;
                    totalAmmount = totalPrice + tax;
                } else {
                    discount = (totalPrice * disCode) / 100;
                    totalAmmount = totalPrice + tax - discount;
                }
            }
        });

        return { totalPrice, totalQuantity, totalAmmount, discount, tax };
    };

    /**
     * Submit form data when order is placed
     */
    onSubmitHandler = (event) => {
        event.preventDefault();
        const { isMilestoneOrder } = this.state;

        if (isMilestoneOrder) {
            this.onMilestoneSubmitHandler(event);
        } else {
            // Regular order submission logic
            const cart = this.props.cart || [];
            console.log(this.state);

            // Check if status is an array and has paid status
            const statusArray = Array.isArray(this.state.status) ? this.state.status : [this.state.status];
            if (statusArray[0] === "paid") {
                let orderStatusData = this.state.orderStatus;
                let orderStatus = "6137423b2651fc157c545d50"; //pending
                console.log(orderStatusData);

                if (Array.isArray(orderStatusData) && orderStatusData.length > 0) {
                    orderStatusData.forEach((d) => {
                        if (d.title == "Completed") {
                            orderStatus = d._id;
                        }
                    });
                }

                let product_sku = this.state.productSku || [];
                let reqBody = {};
                let user = this.authInfo.id;

                reqBody = {
                    count: {
                        page: 1,
                        skip: 0,
                        limit: 2,
                        data: "",
                    },
                    sorting: {
                        sort_type: "date",
                        sort_val: "desc",
                    },
                    data: {
                        userId: this.authInfo.id,
                        productId: product_sku,
                        paymentId: this.state.paymentId,
                        sellerId: product_sku,
                        product_sku: product_sku,
                        billingFirstName: this.state.billingFirstName || '',
                        billingLastName: this.state.billingLastName || '',
                        billingCity: this.state.billingCity || '',
                        billingCompanyName: this.state.billingCompanyName || '',
                        billingCounty: this.state.billingCounty || '',
                        billingNote: this.state.billingNote || '',
                        billingPhone: this.state.billingPhone || '',
                        billingPostCode: this.state.billingPostCode || '',
                        billingStreetAddress: this.state.billingStreetAddress || '',
                        billingStreetAddress1: this.state.billingStreetAddress1 || '',
                        billingEmail: this.state.billingEmail || '',
                        deliveryCharge: 0,
                        taxPercent: 0,
                        taxAmount: 0,
                        discount: 0,
                        price: this.getTotal().totalAmmount,
                        total: this.getTotal().totalAmmount,
                        orderStatus: orderStatus,
                        isActive: true,
                        isService: false,
                    },
                    user_id: this.authInfo.id,
                };
                console.log(reqBody);

                axios.post("user/saveorder", reqBody.data, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: `Bearer ${this.authInfo.token}`,
                    },
                })
                .then((response) => {
                    this.setState({ data: response.status });

                    if (response.status) {
                        this.addOrderTimeLine(response.data.data, orderStatus);
                        this.saveOrderDetails(response.data.data, product_sku, orderStatus);
                        console.log("ORDER SAVED AND REMOVING FROM CART")
                        this.props.dispatch(clearCart());
                        this.clearCartData();
                        localStorage.removeItem('checkoutCartData');
                        localStorage.removeItem('stripeCheckoutCart');
                        localStorage.removeItem('pendingOrderClear');

                        console.log(response)
                        toast.dismiss();
                        toast.success("Order Placed Successfully", { autoClose: 3000 });
                        this.props.history.push("/order-summary/" + response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("Error placing order. Please try again.");
                });
            } else {
                toast.dismiss();
                toast.error("Order is not placed. Please try again.");
            }
        }
    };

    /**
     * Saves the order id and status in the ordertimelime collection
     */
    addOrderTimeLine = (orderId, orderStatus) => {
        let reqBody = {
            data: {
                orderId: orderId,
                orderStatusId: orderStatus,
                isActive: true,
            },
        };
        axios.post("user/saveordertracking", reqBody.data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
        .then((response) => {
            console.log(response.data.data);
        })
        .catch((error) => {
            console.log(error);
            toast.error("Error saving order timeline");
        });
    };

    /**
     * Saves the order id and status in the order details collection
     */
    saveOrderDetails = (orderId, productData, orderStatus) => {
        if (!Array.isArray(productData) || productData.length === 0) {
            console.warn('No product data to save');
            return;
        }

        var prodArray = [];
        for (var i = 0; i < productData.length; i++) {
            if (productData[i]) {
                prodArray.push({
                    orderId: orderId,
                    productId: productData[i].productId || '',
                    quantity: productData[i].quantity || 1,
                    price: productData[i].price || 0,
                    color: productData[i].color || '',
                    size: productData[i].size || '',
                    userId: this.authInfo.id,
                    sellerId: productData[i].sellerId || '',
                    isService: false,
                });
            }
        }

        let reqBody = {
            data: prodArray,
        };

        axios.post("user/saveorderdetails", reqBody.data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
        .then((response) => {
            console.log("Save order details ", response.data.data);
            console.log("ORDER ID CHECK", orderId);
            this.updateOrderStatus(orderId, response.data.data);
        })
        .catch((error) => {
            console.log(error);
            toast.error("Error saving order details");
        });
    };

    /**
     * Update the order status
     */
    updateOrderStatus = (orderId, orderTrackingId) => {
        let reqBody = {
            orderId: orderId,
            orderStatus: orderTrackingId,
        };
        axios.post("user/updateorderstatus", reqBody, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
        })
        .then((response) => {
            console.log("ORDER STATUS", response.data.data);
        })
        .catch((error) => {
            console.log(error);
            toast.error("Error updating order status");
        });
    };

    onChange(evt) {
        const value = evt.target.value;
        this.setState({ ...this.state, [evt.target.name]: value });
    }

    handleSubmit = (values, { setSubmitting }) => {
        const updatedValues = {
            ...values,
            role: 'user'
        };

        const { dispatch } = this.props;
        dispatch(setLoading({ loading: true }));

        axios.put(`user/edit-profile/${this.authInfo.id}`, updatedValues, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": `Bearer ${this.authInfo.token}`
            }
        })
        .then((response) => {
            if (response.data.status) {
                toast.success(response.data.message, { autoClose: 3000 });
                this.setState({ editProfile: false });
            }
        })
        .catch(error => {
            toast.dismiss();
            if (error.response && error.response.data.status === false) {
                toast.error(error.response.data.message, { autoClose: 3000 });
            }
        })
        .finally(() => {
            setTimeout(() => {
                dispatch(setLoading({ loading: false }));
                setSubmitting(false);
            }, 300);
        });
    };

    handleEdit = () => {
        this.setState({ userDetails: this.state.userDetails })
        let editProfile = localStorage.getItem('editProfile');
        console.log('editProfile testttt', editProfile)
        if (editProfile !== null && editProfile === 'false') {
            localStorage.setItem('editProfile', true);
            this.setState({ editProfile: true });
        } else {
            localStorage.setItem('editProfile', false);
            this.setState({ editProfile: false });
        }
    }

    render() {
        const { stripeData, userDetails, editProfile, isMilestoneOrder, milestoneData, sellerId, productSku } = this.state;

        // Initialize reviewOrder variable
        let reviewOrder = [];
        const clientSecret =
            this.props.location?.state?.client_secret ||
            this.state.stripeClientSecret ||
            stripeData?.client_secret ||
            "";

        // Prepare enhanced cart data for Stripe
        const { cartToSend, sellerId: effectiveSellerId } = this.prepareCartDataForStripe();

        // Handle milestone checkout data
        if (isMilestoneOrder && milestoneData) {
            reviewOrder = milestoneData.milestoneCart || [];
        } else {
            if (!clientSecret) {
                return (
                    <React.Fragment>
                        <Header />
                        <PageTitle title="CheckOut" />
                        <div className="inr_wrap checkout_wrap">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="cart my_cart">
                                            <div className="dash_inner_wrap">
                                                <div className="text-center">
                                                    <h4>Loading checkout data...</h4>
                                                    <p>If this persists, please go back to your cart and try again.</p>
                                                    <Link to="/my-cart" className="btn custom_btn btn_yellow">
                                                        Back to Cart
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </React.Fragment>
                );
            }

            if (stripeData?.metadata?.cart) {
                try {
                    reviewOrder = JSON.parse(stripeData.metadata.cart) || [];
                } catch (error) {
                    console.error('Error parsing cart from metadata:', error);
                    reviewOrder = [];
                }
            }
            if (!reviewOrder.length) {
                reviewOrder = this.props.cart || [];
            }
        }

        // Ensure reviewOrder is always an array
        if (!Array.isArray(reviewOrder)) {
            reviewOrder = [];
        }

        const checkoutPricing = stripeData?.pricing || {};
        const orderSubtotal = checkoutPricing.subtotal != null
            ? Number(checkoutPricing.subtotal).toFixed(2)
            : stripeData.amount
                ? (Number(stripeData.amount) / 100).toFixed(2)
                : "0.00";
        const orderPlatformFee = checkoutPricing.platformFee != null
            ? Number(checkoutPricing.platformFee).toFixed(2)
            : null;
        const orderTaxLabel = checkoutPricing.taxLabel || "Tax";
        const orderTaxAmount = checkoutPricing.taxAmount != null
            ? Number(checkoutPricing.taxAmount).toFixed(2)
            : null;
        const orderGrandTotal = checkoutPricing.total != null
            ? Number(checkoutPricing.total).toFixed(2)
            : stripeData.amount
                ? (Number(stripeData.amount) / 100).toFixed(2)
                : "0.00";

        // Create enhanced stripe data with complete cart information
        // In your checkout page prepareCartDataForStripe method
        const enhancedStripeData = {
            ...stripeData,
            metadata: {
                ...stripeData.metadata,
                sellerId: effectiveSellerId || sellerId,
                // REMOVE the cart JSON.stringify line completely
                // Store minimal essential data only
                productIds: cartToSend.slice(0, 10).map(item => item.id).join(','), // Limit to 10 items
                orderType: isMilestoneOrder ? 'milestone' : 'regular',
                isMilestoneOrder: isMilestoneOrder.toString(),
                userId: this.authInfo.id,
                totalItems: cartToSend.length.toString(),
                totalAmount: (stripeData.amount || 0).toString()
            }
        };

        // Store full cart data in localStorage for complete page
        localStorage.setItem('stripeCheckoutCart', JSON.stringify(cartToSend));
        console.log("Stored full cart in localStorage:", cartToSend);

        console.log("=== ENHANCED STRIPE DATA ===");
        console.log("enhancedStripeData.metadata:", enhancedStripeData.metadata);
        console.log("Cart in metadata:", JSON.parse(enhancedStripeData.metadata.cart || '[]'));

        const cart = this.props.cart || [];
        const { history } = this.props;

        // Add safety check for userInfo
        let userInfo = {};
        let fullname = "";
        let first = "";
        let last = "";

        try {
            userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
            fullname = userInfo.name || "";
            if (fullname) {
                const nameParts = fullname.split(" ");
                first = nameParts[0] || "";
                last = nameParts.slice(1).join(" ") || "";
            }
        } catch (error) {
            console.error('Error parsing userInfo:', error);
        }

        // submit Function
        this.onSubmit = () => {
            const couponElement = document.getElementById("myCoupon");
            let disCode = couponElement ? couponElement.value : "";
            let reqBody = {};
            let user = this.authInfo.id;
            reqBody = {
                count: {
                    page: 1,
                    skip: 0,
                    limit: 2,
                    data: "",
                },
                sorting: {
                    sort_type: "date",
                    sort_val: "desc",
                },
                data: disCode,
                user_id: user,
            };

            if (disCode === "") {
                toast.error("Coupon code is blank");
            } else {
                axios.post("user/coupons/check", reqBody, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: `Bearer ${this.authInfo.token}`,
                    },
                })
                .then((response) => {
                    this.setState({ apiData: response.data?.data?.coupons || [] });
                })
                .catch((error) => {
                    console.log(error);
                    toast.error("This code is already used or code does not match");
                });
            }
        };

        this.onValueChange = (event) => {
            this.setState({
                paymentType: event.target.value,
            });

            if (this.state.paymentType === "cripto") {
                this.setState({ moneyComparision: false });
                this.setState({ formStatus: false });
            }
        };

        return (
            <React.Fragment>
                <Header />
                <PageTitle title="CheckOut" />
                <div className="inr_wrap checkout_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="cart my_cart">
                                    <div className="dash_inner_wrap">
                                        {/* Add milestone information banner */}
                                        {isMilestoneOrder && milestoneData && (
                                            <div className="alert alert-info mb-4">
                                                <h5><strong>🎯 Milestone Payment</strong></h5>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <p><strong>Project:</strong> {milestoneData.projectTitle || 'N/A'}</p>
                                                        <p><strong>Current Milestone:</strong> {milestoneData.currentMilestone?.name || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><strong>Amount:</strong> ${milestoneData.currentMilestone?.amount || 0}</p>
                                                        <p><strong>Remaining Milestones:</strong> {milestoneData.remainingMilestones || 0}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <Formik
                                            initialValues={{
                                                name: userDetails.name || '',
                                                email: userDetails.email || '',
                                                phone: userDetails.phone || '',
                                                address: {
                                                    street: userDetails?.address?.street || '',
                                                    city: userDetails?.address?.city || '',
                                                    state: userDetails?.address?.state || '',
                                                    country: userDetails?.address?.country || '',
                                                    zip: userDetails?.address?.zip || '',
                                                }
                                            }}
                                            validationSchema={Yup.object().shape({
                                                name: Yup.string().required("Name is required.").min(3, 'Name is too short - should be 3 chars minimum.').max(50, 'Name is too long - should be 50 chars maximum.'),
                                                email: Yup.string().email().required("Email is required."),
                                                phone: Yup.string().matches(/^[0-9]+$/, "Phone number is not valid").min(10, 'Phone number is too short').max(15, 'Phone number is too long').required("Phone is required."),
                                                address: Yup.object().shape({
                                                    street: Yup.string().required("Street is required."),
                                                    city: Yup.string().required("City is required."),
                                                    state: Yup.string().required("State is required."),
                                                    country: Yup.string().required("Country is required."),
                                                    zip: Yup.number().required("Zip code is required.").positive().integer(),
                                                })
                                            })}
                                            onSubmit={(values, { setSubmitting }) => {
                                                this.handleSubmit(values);
                                                setTimeout(() => {
                                                    setSubmitting(false);
                                                }, 400);
                                            }}
                                            enableReinitialize={true}
                                        >
                                            {({
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                isValid,
                                            }) => (
                                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                                    <div className="row">
                                                        <div className="col-md-12 pt-4 d-flex justify-content-between align-items-center">
                                                            <div className="dash_title">Getting Your Order</div>
                                                            <div className="">
                                                                <span>
                                                                    <Link className="btn custom_btn btn_yellow mx-auto " to="/my-cart">
                                                                        <img src={arrow_back} alt="arrow back" />&nbsp;
                                                                        Back to Cart
                                                                    </Link>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <hr className="my-3" />
                                                        <div className="col-md-6">
                                                            <h5 className="font-semibold">Shipping Information</h5>
                                                            <div className="row mt-5">
                                                                <div className="col-md-6 mb-4">
                                                                    <label htmlFor="firstName" className="form-label">
                                                                        First Name <small className="text-danger">*</small>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="firstName"
                                                                        placeholder="First Name"
                                                                        value={first}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-4">
                                                                    <label htmlFor="lastName" className="form-label">
                                                                        Last Name <small className="text-danger">*</small>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="lastName"
                                                                        placeholder="Last Name"
                                                                        value={last}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="email" className="form-label">Email <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="email"
                                                                    placeholder="Email"
                                                                    onChange={handleChange}
                                                                    value={values.email}
                                                                    disabled={true}
                                                                    maxLength="50"
                                                                />
                                                                {touched.email && errors.email && (
                                                                    <small className="text-danger">{errors.email}</small>
                                                                )}
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="phone" className="form-label">Phone <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="phone"
                                                                    placeholder="Phone"
                                                                    onChange={handleChange}
                                                                    value={values.phone}
                                                                    disabled={true}
                                                                />
                                                                {touched.phone && errors.phone && (
                                                                    <small className="text-danger">{errors.phone}</small>
                                                                )}
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="country" className="form-label">County/Region <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="address.country"
                                                                    placeholder="County/Region"
                                                                    onChange={handleChange}
                                                                    value={values.address.country}
                                                                    disabled={true}
                                                                />
                                                                {touched.address?.country && errors.address?.country && (
                                                                    <small className="text-danger">{errors.address.country}</small>
                                                                )}
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="street" className="form-label">Street Address <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="address.street"
                                                                    placeholder="Street Address"
                                                                    onChange={handleChange}
                                                                    value={values.address.street}
                                                                    disabled={true}
                                                                />
                                                                {touched.address?.street && errors.address?.street && (
                                                                    <small className="text-danger">{errors.address.street}</small>
                                                                )}
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="city" className="form-label">Town/City <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="address.city"
                                                                    placeholder="Town/City"
                                                                    onChange={handleChange}
                                                                    value={values.address.city}
                                                                    disabled={true}
                                                                />
                                                                {touched.address?.city && errors.address?.city && (
                                                                    <small className="text-danger">{errors.address.city}</small>
                                                                )}
                                                            </div>

                                                            <div className="mb-4">
                                                                <label htmlFor="zip" className="form-label">Zip Code <small className="text-danger">*</small></label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="address.zip"
                                                                    placeholder="Zip Code"
                                                                    onChange={handleChange}
                                                                    value={values.address.zip}
                                                                    disabled={true}
                                                                />
                                                                {touched.address?.zip && errors.address?.zip && (
                                                                    <small className="text-danger">{errors.address.zip}</small>
                                                                )}
                                                            </div>

                                                            <div className="form-group text-center mb-4">
                                                                <Link
                                                                    className="btn custom_btn btn_yellow mx-auto" to="/my-profile"
                                                                >
                                                                    Update Profile
                                                                </Link>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <h5 className="text-md font-semibold mb-4 text-center">Review Your Order</h5>
                                                            <div className="checkout_cart_element mt-2">
                                                                <div className="mb-5">
                                                                    {reviewOrder.length > 0 ? (
                                                                        reviewOrder.map((item, index) => (
                                                                            <div className="d-flex justify-content-between align-items-center border-bottom py-2" key={index}>
                                                                                <div className="product-data text-start">
                                                                                    <h6 className="mb-1">{`${index + 1}) ${item.name ? item.name.split(' ').slice(0, 4).join(' ') : 'Product'}${item.name && item.name.split(' ').length > 4 ? '...' : ''}`}</h6>
                                                                                </div>
                                                                                <div className="product-quantity text-end">
                                                                                    <h6 className="mb-1"><b>{`${item.quantity || 1}`}</b> qty.</h6>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            <p>No items found in cart</p>
                                                                        </div>
                                                                    )}
                                                                    <div className="cart_footer cart_wrap border-bottom">
                                                                        <div className="cart_foot_price">
                                                                            <div className="cfp"><span>Total Item</span> <b>{reviewOrder.length || 0}</b></div>
                                                                            <div className="cfp"><span>Subtotal (items)</span> <b>${orderSubtotal}</b></div>
                                                                            {orderPlatformFee != null ? (
                                                                                <div className="cfp"><span>Platform fee</span> <b>${orderPlatformFee}</b></div>
                                                                            ) : null}
                                                                            <div className="cfp">
                                                                                <span>{orderTaxLabel}</span>
                                                                                <b>{orderTaxAmount != null ? `$${orderTaxAmount}` : "—"}</b>
                                                                            </div>
                                                                            <div className="cfp"><span>Grand Total</span> <b>${orderGrandTotal}</b></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-4 link-checkout-parent">
                                                                    <div className="link-checkout">
                                                                        {clientSecret ? (
                                                                        <StripeCheckoutElements
                                                                            stripePromise={stripePromise}
                                                                            clientSecret={clientSecret}
                                                                            checkoutFormProps={{
                                                                                stripeData: enhancedStripeData,
                                                                                sellerId: effectiveSellerId || sellerId,
                                                                                productSku: productSku,
                                                                                cart: cartToSend,
                                                                            }}
                                                                        />
                                                                        ) : (
                                                                        <p className="text-muted small text-center mb-0">
                                                                            Payment session missing. Return to cart and place order again.
                                                                        </p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cart: state?.cart?.cart || [],
    };
};

export default connect(mapStateToProps)(CheckOut);
